import Button from 'react-bootstrap/esm/Button';
import { useLocales } from '../../locales';
import * as PropTypes from 'prop-types';

export function ChangeDisplayMode({ setDisplay, display, title, small }) {
  const { translate: t } = useLocales();
  return (
    <Button
      variant="light"
      size="xs"
      onClick={() => {
        setDisplay(!display);
      }}
      className={`fs-7 d-flex align-items-center bg-white mr-2 text-dark shadow  justify-content-end ${
        small ? 'p-2 px-4' : ''
      }`}
    >
      <div className="d-flex flex-row align-items-center justify-content-end">
        <span style={{ fontWeight: 500 }} className="fs-7">
          {t(title)}
        </span>
        <div>
          <span className="form-check form-switch d-flex">
            <label className="mb-0">
              <input
                type="checkbox"
                className="form-check-input  cursor-pointer ms-1"
                checked={display}
                onChange={() => {}}
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>
    </Button>
  );
}

ChangeDisplayMode.propTypes = {
  setDisplay: PropTypes.func,
  display: PropTypes.bool,
  title: PropTypes.string,
  small: PropTypes.bool
};
